module.exports = __webpack_public_path__ + "static/media/Monstruos de mousse.6c5ad6ab.webp";